export default __webpack_public_path__ + "static/media/4.e400635d.jpg";